module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/0lEQVQ4jaWUwUrEMBCGv7aasgiCsLLBk8d9DvPceQ8vC54kYk9FaFMp9bAJJDFmDfvfMjP5+JPMpNm2jZJ6qe6BHTBZo8dSbVOCOdBzEHorAduiLXi6sP4frJfqARBJWLh4Vtlj9lLtL7h4t0YPWZi7m0fgNuOmpAX4Bj6t0WMjDi8COFYA/tJrW+mkJNFao7+A+UrQDEz+NU9XAGfgZI1eWwBr9OqASyVo8SAI+swFiuOS0ehBEcwna2HhIoXdVcKi+hRW2yZR/U2S7DIbfJfnpiOqT2EDZ+sdsAKDNfrDJ3upDsA+zIebfw16L5VwDqbwpYJ8x/mzXKzRUSv9AJUPYFacWSKBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty-star.png
// module id = 20
// module chunks = 0